<p>translation-add-csv works!</p>
<form [formGroup]="entityForm" (submit)="onEntityFormSubmit()">
  <h4>Edit "Test"</h4>

  <div class="form-group">
    <label for="csv">Example textarea</label>
    <textarea class="form-control" id="csv" rows="4" formControlName="csv"></textarea>
  </div>

  <div class="row no-gutters mt-4">
    <div class="col-12">
      <button type="submit" class="btn at-ct-btn-ib-white-with-dark-bg me-2">Update</button>
      <button type="button" class="btn btn-danger" (click)="cancelFormSubmit()">Cancel</button>
    </div>
  </div>
</form>
